import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const CreateNewAttribute: React.ComponentType<SvgIconProps> = props => (
  <SvgIcon {...props} viewBox="0 0 264 126">
    <svg fill="none">
      <path fill="#F9FBFD" d="M0 0h264v125.832H0z" />
      <rect
        opacity={0.4}
        x={72}
        y={43}
        width={120}
        height={34}
        rx={17}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <path
        opacity={0.5}
        d="M96.073 65.168a4.552 4.552 0 0 1-1.638-.294 4.005 4.005 0 0 1-1.358-.896 4.247 4.247 0 0 1-.91-1.456c-.224-.588-.336-1.265-.336-2.03 0-.756.117-1.428.35-2.016a4.564 4.564 0 0 1 .938-1.512c.392-.41.85-.723 1.372-.938a4.305 4.305 0 0 1 1.652-.322c.588 0 1.116.121 1.582.364.467.233.854.509 1.162.826l-1.092 1.316a3.23 3.23 0 0 0-.742-.518 1.757 1.757 0 0 0-.868-.21c-.308 0-.602.07-.882.21-.27.13-.508.322-.714.574-.196.252-.354.56-.476.924a4.184 4.184 0 0 0-.168 1.232c0 .943.201 1.675.602 2.198.402.513.938.77 1.61.77.374 0 .705-.08.994-.238.299-.168.56-.373.784-.616l1.092 1.288c-.765.896-1.75 1.344-2.954 1.344Zm4.741-.168v-9.128h3.29c.485 0 .938.047 1.358.14.429.093.802.252 1.12.476.317.215.569.504.756.868.186.364.28.817.28 1.358 0 .672-.15 1.227-.448 1.666a2.67 2.67 0 0 1-1.176.966L108.066 65h-2.31l-1.75-3.29h-1.134V65h-2.058Zm2.058-4.928h1.064c.541 0 .952-.112 1.232-.336.289-.233.434-.574.434-1.022 0-.448-.145-.76-.434-.938-.28-.177-.691-.266-1.232-.266h-1.064v2.562ZM109.8 65v-9.128h5.712v1.736h-3.654v1.834h3.108v1.722h-3.108v2.1h3.794V65H109.8Zm10.212-4.62-.224.84h1.946l-.21-.84a31.74 31.74 0 0 1-.378-1.456 98.303 98.303 0 0 0-.364-1.484h-.056c-.112.485-.229.985-.35 1.498-.112.504-.234.985-.364 1.442ZM116.708 65l2.856-9.128h2.478L124.898 65h-2.184l-.56-2.17h-2.786l-.56 2.17h-2.1Zm10.34 0v-7.392h-2.506v-1.736h7.084v1.736h-2.506V65h-2.072Zm6.401 0v-9.128h5.712v1.736h-3.654v1.834h3.108v1.722h-3.108v2.1h3.794V65h-5.852Zm11.273 0v-9.128h2.114l2.38 4.536.896 2.016h.056c-.047-.485-.103-1.027-.168-1.624a18.327 18.327 0 0 1-.084-1.708v-3.22h1.96V65h-2.114l-2.38-4.55-.896-1.988h-.056c.046.504.098 1.045.154 1.624.065.579.098 1.139.098 1.68V65h-1.96Zm9.71 0v-9.128h5.712v1.736h-3.654v1.834h3.108v1.722h-3.108v2.1h3.794V65h-5.852Zm8.882 0-1.694-9.128h2.114l.63 4.27c.056.476.117.957.182 1.442.065.476.126.957.182 1.442h.056c.093-.485.182-.966.266-1.442.093-.485.187-.966.28-1.442l.98-4.27h1.75l.98 4.27c.093.467.182.943.266 1.428.093.476.187.961.28 1.456h.056c.065-.495.126-.98.182-1.456l.196-1.428.63-4.27h1.974L171 65h-2.59l-.896-4.144c-.075-.355-.145-.71-.21-1.064a77.507 77.507 0 0 1-.154-1.05h-.056c-.056.336-.117.686-.182 1.05-.056.355-.121.71-.196 1.064L165.862 65h-2.548Z"
        fill="#000"
      />
      <g filter="url(#a)" opacity={0.5}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="m179.026 84.088.004-.007.022.082-.026-.075Zm1.495 5.472a.51.51 0 0 1 .092-.29l.848-1.194a2.928 2.928 0 0 0 .542-1.703v-4.876c0-2.075-.221-2.417-.976-2.481v1.481a.499.499 0 1 1-1 0v-1.925c-.058-.176-.288-.653-1.058-.643v2.568a.5.5 0 1 1-1 0v-2.903c-.094-.166-.371-.552-.885-.597v3.5a.5.5 0 1 1-1 0v-3.424c-.001-.012-.007-.022-.007-.034v-2.042c0-.558-.387-.986-.9-.997-.547.012-1.064.487-1.064.997v7.157a.5.5 0 0 1-.887.318l-1.527-1.862a1.027 1.027 0 0 0-.712-.291h-.001c-.272 0-.536.115-.744.325-.328.333-.316.891.026 1.244l1.38 1.976c.619.889 1.117 1.86 1.479 2.884.329 1.004 1.099 2.473 1.718 2.473a.5.5 0 0 1 .5.499l.001.777h5.175v-.937Z"
          fill="#fff"
        />
        <mask
          id="b"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={182}
          y={80}
          width={2}
          height={2}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M183.085 80.882v1h-.102v-1h.102Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#b)">
          <path fillRule="evenodd" clipRule="evenodd" d="M182.983 80.882Z" fill="#fff" />
        </g>
        <mask
          id="c"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={173}
          y={92}
          width={2}
          height={2}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M174.341 93.498h-1v-.662h1v.662Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#c)">
          <path fillRule="evenodd" clipRule="evenodd" d="M173.341 92.836Z" fill="#fff" />
        </g>
        <mask
          id="d"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={182}
          y={90}
          width={2}
          height={2}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M183.085 90.615v1h-.916v-1h.916Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#d)">
          <path fillRule="evenodd" clipRule="evenodd" d="M182.169 90.615Z" fill="#fff" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M174.001 90.615ZM181.585 91.498h-7a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1Z"
          fill="#fff"
        />
        <mask
          id="e"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={182}
          y={93}
          width={2}
          height={1}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M183.085 93.058v.44h-.917v-.44h.917Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#e)">
          <path fillRule="evenodd" clipRule="evenodd" d="M182.645 93.058Z" fill="#fff" />
        </g>
        <mask
          id="f"
          style={{
            maskType: 'alpha',
          }}
          maskUnits="userSpaceOnUse"
          x={169}
          y={72}
          width={15}
          height={22}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M176.042 93.498H169V72.999h14.085v20.499h-7.043Z"
            fill="#fff"
          />
        </mask>
        <g mask="url(#f)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M181.585 92.498h-7a.5.5 0 0 1 0-1h7a.5.5 0 0 1 0 1Zm-6.237-2-.002-.779a.5.5 0 0 0-.5-.498c-.618 0-1.389-1.47-1.718-2.472a12.043 12.043 0 0 0-1.479-2.884l-1.379-1.977c-.343-.353-.355-.912-.027-1.244a1.05 1.05 0 0 1 .744-.326h.001c.272 0 .536.117.712.293l1.528 1.86a.5.5 0 0 0 .886-.317v-7.156c0-.511.517-.987 1.064-.999.513.011.9.44.9.999v2.041c0 .013.006.022.007.034v3.425a.5.5 0 0 0 1 0v-3.502c.514.047.791.431.885.599v2.903a.5.5 0 1 0 1 0v-2.57c.77-.008 1 .469 1.058.644v1.925a.5.5 0 0 0 1 0v-1.48c.755.064.976.406.976 2.48v4.876c0 .615-.188 1.204-.542 1.703l-.848 1.195a.508.508 0 0 0-.091.288V90.498h-5.175Zm7.298.438a1.493 1.493 0 0 0-1.061-.439h-.062v-.778l.755-1.063c.475-.67.726-1.46.726-2.284v-4.874c0-.1-.007-.174-.009-.267a12.574 12.574 0 0 0-.011-.35c-.099-2.34-.774-2.805-2.109-2.873-.281-.552-.939-1.175-2.139-1.07a2.136 2.136 0 0 0-1.448-.907.49.49 0 0 0-.203-.046h-.007v-.987c0-1.1-.825-1.977-1.9-1.999-1.118.023-2.064.939-2.064 1.999v5.76l-.672-.816a2.031 2.031 0 0 0-1.454-.623h-.001c-.541 0-1.058.22-1.455.623-.708.717-.699 1.902-.032 2.58l1.329 1.912a11.084 11.084 0 0 1 1.352 2.636c.153.468.909 2.59 2.166 3.059l.001.392a1.48 1.48 0 0 0-.347.094 1.493 1.493 0 0 0-.916 1.382 1.493 1.493 0 0 0 .916 1.382c.18.076.377.118.584.118h7a1.493 1.493 0 0 0 1.061-.439 1.499 1.499 0 0 0 0-2.122Z"
            fill="#212121"
          />
        </g>
      </g>
      <defs>
        <filter
          id="a"
          x={166}
          y={70.999}
          width={20.085}
          height={26.498}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0 0.129412 0 0 0 0.2 0" />
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_1606_87691" />
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_1606_87691" result="shape" />
        </filter>
      </defs>
    </svg>
  </SvgIcon>
);

export default CreateNewAttribute;
